<template>
  <div class="sub-nav-links-component" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="subnav-container">
      <div class="nav-links-container nav-links-container--desktop visible-md visible-lg">
        <a class="btn" href="#">Shop Online Inventory</a>
        <a class="btn" href="#">Find Parts</a>
        <a class="btn" href="#">Buy Accessories</a>
      </div>
      <div class="nav-links-container nav-links-container--mobile visible-xs visible-sm">
        <div class="dropdown">
          <a id="subNavLinksDropdown" class="btn dropdown-button" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Quick Actions<span class="dropdown-arrow"></span></a>
          <ul class="dropdown-menu" aria-labelledby="subNavLinksDropdown">
            <li>
              <a class="btn" href="#">Shop Online Inventory</a>
            </li>
            <li>
              <a class="btn" href="#">Find Parts</a>
            </li>
            <li>
              <a class="btn" href="#">Buy Accessories</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="primary-btn-container">
        <a class="primary-button secondary-btn" :class="brandButtonClass" href="#">Schedule Service</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        brand: this.$store.state.chosenBrand,
      }
    },
    computed: {
      brandButtonClass() {
        if (this.brand.toLowerCase() !== 'none') {
          return this.brand.toLowerCase() + '-btn';
        } else {
          return 'default-btn';
        }
      }
    },
    mounted() {
      (function($){
        const subNavLinks = {
          init: function() {
            subNavLinks.setHeight();
          }, 

          resize: function() {
            subNavLinks.setHeight();
          }, 

          setHeight: function() {
            const subnav = $('#sub-nav-links-component');
            const height = subnav.find('.navbar-fixed-top').height();
            subnav.css({'height':height});
          }
        }

        $(document).ready(subNavLinks.init);
        $(window).resize(subNavLinks.resize);

      })(jQuery)
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped> 
.sub-nav-links-component {
  border-top: solid 2px #e7e7e7;
  border-bottom: solid 2px #e7e7e7;
}
.sub-nav-links-component a {
  font-size: 11px;
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  position: relative;
}
.sub-nav-links-component .nav-links-container a {
  color: #000000;
  color: var(--primary-dark);
}
.sub-nav-links-component .nav-links-container a:hover {
  opacity: 0.4;
}

.sub-nav-links-component .btn, 
.sub-nav-links-component .btn:hover, 
.sub-nav-links-component .btn:active, 
.sub-nav-links-component .btn:focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.sub-nav-links-component .dropdown-menu > li > a:hover, 
.sub-nav-links-component .dropdown-menu > li > a:focus, 
.sub-nav-links-component .dropdown-menu > li > a:active {
  color: #000000;
  color: var(--primary-dark);
  background-color: rgba(255, 255, 255, 0);
}

.sub-nav-links-component .dropdown-menu {
  width: calc(100vw - 12px);
  top: calc(100% + 6px);
  margin: 0;
  border: 0;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 7px 15px;
  background-color: rgba(255, 255, 255, 0.85);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.sub-nav-links-component .dropdown-menu > li > a {
  padding: 13px 12px;
  width: fit-content;
  border: 0;
}

/* General Styles */

.sub-nav-links-component, 
.sub-nav-links-component .subnav-container {
  background-color: #ffffff;
}

.sub-nav-links-component .subnav-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.sub-nav-links-component .nav-links-container--desktop {
  padding: 20px 0;
}

.sub-nav-links-component .nav-links-container--desktop a {
  padding: 0 12px;
  border: 0;
  border-right: solid 1px #dddddd;
  border-radius: 0;
}

.sub-nav-links-component .nav-links-container--desktop a:last-child {
  border-right: 0;
}

.sub-nav-links-component .primary-button {
  padding: 12px 25px;
  margin: 10px;
  display: block;
}

.sub-nav-links-component .dropdown-button {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.sub-nav-links-component .dropdown-arrow {
  display: inline-block;
  margin-left: 5px;
  width: 12px;
  height: 12px;
  background-image: url("../../static/images/common-icons/right-arrow-black.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  -ms-transform: rotateZ(90deg);
  -moz-transform: rotateZ(90deg);
  -webkit-transform: rotateZ(90deg);
  transform: rotateZ(90deg);
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.sub-nav-links-component .dropdown.open .dropdown-arrow {
  -ms-transform: rotateZ(-90deg);
  -moz-transform: rotateZ(-90deg);
  -webkit-transform: rotateZ(-90deg);
  transform: rotateZ(-90deg);
}

.nav-right-with-contact.show-mobile-nav ~ .sub-nav-links-component, 
.nav-right-with-contact.show-mobile-nav ~ .sub-nav-links-component .navbar-fixed-top {
  background-color: #f8f8f8;
}

@media (min-width: 1501px) {
  
  .sub-nav-links-component .subnav-container {
    width: 1500px;
  }

}

@media (max-width: 1199px) {
  
  .sub-nav-links-component, 
  .sub-nav-links-component .navbar-fixed-top {
    background-color: #f8f8f8;
  }

}

@media (max-width: 991px) { 

  .sub-nav-links-component a {
    font-size: 10px;
  }
  
  .sub-nav-links-component .primary-button {
    padding: 7px 12px;
    margin: 5px 0;
  }

  .sub-nav-links-component .subnav-container {
    padding-left: 5px;
    padding-right: 5px;
  }

  .sub-nav-links-component .dropdown-button {
    padding: 10px 12px;
    border: 0;
  }

  .sub-nav-links-component .dropdown-arrow {
    width: 10px;
    height: 10px;
    margin-left: 5px;
  }

  .sub-nav-links-component .dropdown-menu {
    padding: 7px;
  }

}

/* Mazda */

.sub-nav-links-component[data-brand="mazda"], 
.sub-nav-links-component[data-brand="mazda"] .navbar-fixed-top {
  background-color: #ffffff !important;
}

.sub-nav-links-component[data-brand="mazda"] .navbar-fixed-top {
  border-bottom: solid 2px #d5d5d5;
}

.sub-nav-links-component[data-brand="mazda"] a {
  font-size: 11px;
  letter-spacing: 2.8px;
}

.sub-nav-links-component[data-brand="mazda"] .primary-button {
  letter-spacing: 1.69px;
  padding: 15px 35px;
  margin: 10px 12px;
}

.sub-nav-links-component[data-brand="mazda"] .nav-links-container--desktop {
  padding: 25px 0;
}

.sub-nav-links-component[data-brand="mazda"] .nav-links-container--desktop a {
  padding: 0 19px;
}

.sub-nav-links-component[data-brand="mazda"] .dropdown-menu > li > a {
  padding: 10px 12px;
}

@media (max-width: 991px) {

  .sub-nav-links-component[data-brand="mazda"] a {
    font-size: 9px;
  }
  
  .sub-nav-links-component[data-brand="mazda"] .primary-button {
    padding: 10px;
    margin: 0 -10px;
    border: 0;
  }

}

/* All Brands */

.sub-nav-links-component .nav-links-container--desktop a:first-child {
  padding-left: 0;
}
</style>
